import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog"

export interface SsoChange {
  label: string
  from: string | null
  to: string | null
}

const normalize = (value: string | null) =>
  (value ?? "").trim().toLowerCase() || null

export function ssoChanges(
  current: { sso_domain: string | null; entra_tenant_id: string | null },
  next: { sso_domain: string | null; entra_tenant_id: string | null }
): SsoChange[] {
  const changes: SsoChange[] = []
  if (normalize(current.sso_domain) !== normalize(next.sso_domain)) {
    changes.push({
      label: "Google SSO domain",
      from: current.sso_domain,
      to: normalize(next.sso_domain),
    })
  }
  if (normalize(current.entra_tenant_id) !== normalize(next.entra_tenant_id)) {
    changes.push({
      label: "Microsoft Entra tenant ID",
      from: current.entra_tenant_id,
      to: normalize(next.entra_tenant_id),
    })
  }
  return changes
}

export function SsoChangeConfirmDialog({
  open,
  onOpenChange,
  changes,
  onConfirm,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  changes: SsoChange[]
  onConfirm: () => void
}) {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Change SSO settings?</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-3 text-sm">
              <ul className="list-disc space-y-1 pl-5">
                {changes.map((c) => (
                  <li key={c.label}>
                    {c.label}:{" "}
                    {c.to === null
                      ? `${c.from ?? "not set"} will be cleared`
                      : `${c.from ?? "not set"} → ${c.to}`}
                  </li>
                ))}
              </ul>
              <p>
                Changing these settings affects how users sign in. New SSO
                sign-ins and automatic account creation will use the new values
                immediately. Existing users keep their password sign-in. A typo
                can silently disable SSO for new users.
              </p>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>
            Yes, change SSO settings
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
